// extracted by mini-css-extract-plugin
module.exports = {"label":"apply_label__2UqAq","errorMessage":"apply_errorMessage__3b98y"};